<style lang="scss">
  .cartContent {
    .text-center {
      p {
        margin-top: 70px;
        font-size: 34px;
        font-weight: 800;
        text-transform: uppercase;
      }
    }
    .books {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-column-gap: 50px;
      grid-row-gap: 80px;
      p:nth-of-type(2) {
        font-size: 16px;
      }
    }
  }
</style>
<template>
  <div class="cartContent">
    <FrontendNav></FrontendNav>
    <div class="container">
      <h1>Összegzés</h1>
      <p class="orderProgress">
        <span>Rendelés adatok</span> <i></i> <span>Fizetés</span> <i></i> <span class="active">Összegzés</span>
      </p>
      <div class="text-center" style="margin-bottom: 120px">
        <p>Valami hiba történt</p>
        <a href="/kosar" class="btn btn-primary">Vásárlás újrakezdése</a>
      </div>
    </div>
    <FrontendFooter></FrontendFooter>
  </div>
</template>

<script>
import FrontendNav from '../partials/nav'
import FrontendFooter from '../partials/footer'

export default {
  name: 'OrderSuccess',
  components: {
    FrontendNav,
    FrontendFooter
  },
  data: function () {
    return {
    }
  },
  mounted: function () {
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/frontend/order/error.vue